import React from "react";
import "./App.css";

import { Provider } from "react-redux";
import { loadUser, OidcProvider, LOADING_USER } from "redux-oidc";
import configureStore from "./redux/store";

import moment from "moment";
import "moment/locale/vi";

// React router dom
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";

// Components
import LayoutAuthenticated from "./containers/LayoutAuthenticated";

// Services
import userManager from "./services/auth";

import CallBack from "./routes/callback";
import SilentRenew from "./routes/silentRenew";
import BaoCaoThongKe from "./routes/BaoCaoThongKe";
import License from './routes/licenses'
import Dashboard from './routes/TrangChu'
import withAuth from "./HOC/withAuth";
import DanhMuc from "./routes/DanhMuc";
import DanhMucQuanTrac from "./routes/DanhMucQuanTrac";
import NhatKyHeThong from "./routes/NhatKyHeThong/router";
import CauHinhThongSo from "./routes/CauHinhThongSo";
import HienTrangMT from "./routes/HienTrangMoiTruong";
import TTKT from "./routes/ThanhTraKiemTra";
import TCDN from "./routes/TraCuuDoanhNghiep/DNXCP";
import DTM from "./routes/DTM";
import QTVHL from "./routes/QTVinhHaLong";
import BVMT from "./routes/BaoVeMoiTruong";
import NTTS from "./routes/NuoiTrongThuySan";
import TraCuuTNN from "./routes/BanDo/TraCuuTNN/map";
import SongVaLuuVuc from "./routes/ThongTinTaiNguyenNuoc/SongVaLuuVuc";
import Profile from "./routes/Profile";
import CongAnTinh from "./routes/CongAnTinh"
import BaoCaoChoDoanhNghiep from "./routes/BaoCaoDanhChoDoanhNghiep"
import ChangePassword from "./routes/ChangePassword"
moment.locale("vi");
// Retry function
const retry = (fn, retriesLeft = 1, interval = 1000) => {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch(error => {
        setTimeout(() => {
          if (retriesLeft < 1) {
            reject("Loading chuck failure!");
          }
          retry(fn, retriesLeft - 1, interval);
        }, interval);
      });
  });
};

// Store
const store = configureStore(window.REDUX_INITIAL_DATA);
function App() {
  const hash = window.location.hash;
  if (hash === "" || hash === null || hash === undefined) {
    userManager.getUser()
      .then((res) => {
        if (!res) {
          userManager.signinRedirect();
        }
        else {
          loadUser(store, userManager).then(() => {
            userManager.events.addUserSignedOut(() => userManager.signoutRedirect())
          });
        }
      });
  }
  return (
    <Provider store={store}>
      <OidcProvider store={store} userManager={userManager}>
        <Switch>
          <Route path="/callback" component={CallBack} />
          <Route path="/silentrenew" component={SilentRenew} />
          <LayoutAuthenticated userManager={userManager}>
            <Route exact path="/" component={() => <Redirect to="/dashboard" />} />
            <Route path="/dashboard" component={withAuth(Dashboard)} />
            <Route path="/collections" component={withAuth(Dashboard)} />
            <Route path="/bao-cao-thong-ke" component={withAuth(BaoCaoThongKe)} />
            <Route path="/tai-nguyen-nuoc" component={withAuth(License)} />
            <Route path="/Danh-muc" component={withAuth(DanhMuc)} />
            <Route path="/QT-vinh-ha-long" component={withAuth(QTVHL)} />
            <Route path="/Tra-cuu-doanh-nghiep" component={withAuth(TCDN)} />
            <Route path="/Danh-muc-quan-trac" component={withAuth(DanhMucQuanTrac)} />
            <Route path="/Nhat-ky-he-thong" component={withAuth(NhatKyHeThong)} />
            <Route path="/Cau-hinh-thong-so" component={withAuth(CauHinhThongSo)} />
            <Route path="/hien-trang-moi-truong" component={withAuth(HienTrangMT)} />
            <Route path="/bao-ve-moi-truong" component={withAuth(BVMT)} />
            <Route path="/DTM" component={withAuth(DTM)} />
            <Route path="/nuoi-trong-thuy-san" component={withAuth(NTTS)} />
            <Route path="/Thanh-tra-kiem-tra" component={withAuth(TTKT)} />
            <Route path="/Ban-do/Tra-cuu-tai-nguyen-nuoc" component={withAuth(TraCuuTNN)} />
            <Route path="/my-profile" component={withAuth(Profile)} />
            <Route path="/Cong-an-tinh" component={withAuth(CongAnTinh)} />
            <Route path="/BCDN" component={withAuth(BaoCaoChoDoanhNghiep)} />
            <Route path="/change-password" component={withAuth(ChangePassword)} />
          </LayoutAuthenticated>    
        </Switch>
      </OidcProvider>
    </Provider>
  );
}

// Global router
window.globalRouter = null;
export default () => (<Router basename="" ref={node => (window.globalRouter = node)}><App /></Router>)
